import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ValidateResponse } from "../helpers/global";
import { fetchDocumentSignData, processSignature } from "../helpers/transport";

import { Message } from "../../components/Message";
import { FormFields } from "../../components/Form/Fields";
import { returnValues, removeValue, validateData } from "../../components/Form/Formfunctions";
import { ContentWrapper } from "../../components/Content/Wrapper";

export function AppTransportSign({ stopId, setPageTitle, parents = "transport/active" }) {

    const location = useLocation();
    const navigate = useNavigate();
    const [state, setState] = useState();
    const [isLoaded, setIsLoaded] = useState(false);
    const [hidden, setHidden] = useState(false);

    const [checkedDamage, setCheckedDamage] = useState(false);
    const [checkedMail, setCheckedMail] = useState(false);

    const [values, setValues] = useState({});
    const [errors, setErrors] = useState();
    const [error, setError] = useState();
    const [warning, setWarning] = useState();
    const [isSubmitted, setSubmitted] = useState(false);
    const currentDate = new Date();
    const documentType = location.state.documentType;
    const notRequired = ['DEPOT-CASE', 'RENTAL-TERMINATION'];
    const [isProcessing, setisProcessing] = useState(false);

    useEffect(() => {

        var callData = {
            'stopId': stopId,
            'documentType': documentType
        }
        fetchDocumentSignData(callData).then((res) => {

            const response = ValidateResponse(res.data, 'stop');

            if (response.status === 'error') {
                setError(response.message);
                return;
            }
            else {
                setState(response.stop);
                let pageTitle = response.stop.documentName + " ondertekenen";
                setPageTitle(pageTitle);
                setIsLoaded(true);
            }
        }).catch((error) => {
            let response = ValidateResponse(error);
            setError(response.message);
            console.log(error);
        })
    }, [setState, stopId, navigate, documentType, setPageTitle])

    if (isProcessing === true) {
        return <Message type="loading" message="Ondertekening wordt verwerkt" />
    }
    if (error !== undefined) {
        return <Message type="error" message={error} />
    }
    if (state === undefined || state.document === undefined || state.document === null) {
        return <Message type="noData" />
    }
    if (isLoaded === false) {
        return <Message type="loading" />
    }

    const setInputValues = (key, value, identifier = null) => {

        if (key === 'damage') {
            setCheckedDamage(value);
        }
        if (key === 'mailRequest') {
            setCheckedMail(value);
        }

        // reset errors
        if (isSubmitted === true) {
            setSubmitted(false);
        }
        if (errors) {
            setErrors(removeValue(errors, key, identifier));
        }

        setValues(returnValues(values, key, value, identifier));
    }

    const setInputErrors = (key, value, identifier = null) => {

        // add or remove error
        let newErrors = errors;
        if (value !== undefined && value !== null) {
            newErrors = returnValues(errors, key, value, identifier);
        }
        else {
            newErrors = removeValue(errors, key, identifier);
        }
        setErrors(newErrors);
    }

    const showHide = () => {
        setHidden(!hidden);
    }


    // Set fields
    let rules = notRequired.includes(documentType) ? [] : ["required"];
    let marker = notRequired.includes(documentType) ? "" : " *";

    let defaultValues = {
        signDate: currentDate.toISOString().split('T')[0],
        // nameClient: state.info.contactName ? state.info.contactName.value : null, #1722 name client should NOT be prefilled anymore
        nameEmployee: state.signing.employee.name,
        email: state.signing.customer.email,
        comments: null // state.combinedRemarks ?? null // #1681 At signing we do NOT add the delivery remarks in the signing field, this remakrs are only for damage/ stuff that is related to siging. The delivery remakrs are shown separately on the (rental) document
    }

    if (Object.keys(values).length === 0) {
        setValues(defaultValues);
    }

    // De commentClient kun je hier niet aanpassen
    // formFields.commentClient = {
    //     type: "textarea",
    //     label: "Opmerkingen (klantbon)"
    // }

    let formFields = {
        signDate: {
            type: "date",
            label: state.processDateLabel + marker,
            options: { min: "-1", max: "+1" },
            value: values['signDate'],
            rules: rules
        }
    }

    if (state.signing.employee.sign === true) {
        formFields.nameEmployee = {
            type: "text",
            label: "In ontvangst genomen door (medewerker)" + marker,
            value: values['nameEmployee'],
            rules: rules
        }
    }

    formFields.mailRequest = {
        type: "checkbox",
        label: state.documentName + " mailen"
    }

    if (checkedMail === true) {
        formFields.email = {
            type: "text",
            label: "E-mail voor ontvangstbevestiging" + marker,
            value: values['email'],
            rules: rules.concat(['email'])
        }
    }

    // Bij ophalen door medewerker: check op beschadigingen
    if (state.signing.employee.sign === true) {
        formFields.damage = {
            type: "checkbox",
            label: "Beschadigingen"
        }
    }

    if (state.signing.customer.sign === true || checkedDamage === true || documentType === 'DEPOT-CASE') {
        formFields.nameClient = {
            type: "text",
            label: "Naam klant" + marker,
            value: values['nameClient'],
            rules: rules
        }
    }

    if (values.damage !== undefined && values.damage === true) {
        formFields.comments = {
            type: "textarea",
            label: "Opmerkingen (beschadigingen)"
        }
    }


    // Dusssss.... als het een pickup is dan GEEN handtekening medewerker bij al
    if (state.signing.employee.sign === true) {
        formFields.sigEmployee = {
            type: "signature",
            label: "Handtekening medewerker" + marker,
            rules: rules
        }
    }

    // En als het een dropoff (dus bij ophalen WEL een handtekening klant ) ...eh nee andersom toch ... ik snap dit niet :(
    if (state.signing.customer.sign === true || checkedDamage === true) {
        formFields.sigClient = {
            type: "signature",
            label: "Handtekening klant" + marker,
            rules: rules
        }
    }

    // Submit (after set )
    const handleSubmit = () => {

        setSubmitted(true);

        let validation = validateData(formFields, values, true);

        if (validation.status !== 'success') {
            setErrors(validation.errors);
            return;
        }

        if ((values.sigEmployee !== undefined && values.sigEmployee !== null)
            && (values.nameEmployee === undefined || values.nameEmployee === null || values.nameEmployee === "")) {
            setErrors({ nameEmployee: "Naam medewerker mist" });
            return;
        }
        if ((values.sigClient !== undefined && values.sigClient !== null)
            && (values.nameClient === undefined || values.nameClient === null || values.nameClient === "")) {
            setErrors({ nameClient: "Naam medewerker mist" });
            return;
        }

        if ((values.sigEmployee === undefined || values.sigEmployee === null)
            && (values.damage !== undefined && values.damage === true)) {
            setErrors({ sigEmployee: "Handtekening is verplicht bij beschadigingen" });
            return;
        }
        if ((values.sigClient === undefined || values.sigClient === null)
            && (values.damage !== undefined && values.damage === true)) {
            setErrors({ sigClient: "Handtekening is verplicht bij beschadigingen" });
            return;
        }

        const formData = {
            'documentType': documentType,
            'stopId': stopId,
            'nameEmployee': values.nameEmployee,
            'nameClient': values.nameClient,
            'email': values.email,
            'signatureEmployee': values.sigEmployee,
            'signatureClient': values.sigClient,
            'comments': values.comments,
            // 'commentClient': values.commentClient,
            'damage': values.damage,
            'mailRequest': values.mailRequest,
            'date': values.signDate,
        }

        let globalErrorMessage = "Er is is een fout opgetreden met genereren/mailen van de "
            + state.documentName.toLowerCase();

        let globalSuccessMessage = null;

        setisProcessing(true);

        processSignature(formData).then((res) => {

            let message;
            let response = ValidateResponse(res.data, 'response');

            setisProcessing(false);

            if (response.status === 'success' || response.status === 'warning') {
                message = response.message ?? globalSuccessMessage;
            } else {
                message = response.message ?? globalErrorMessage;
            }

            // More documents to sign?
            if (response.status === 'warning') {
                setWarning(message);
            }
            else if (state.signing.moreToSign === false) {
                navigate("/" + parents + "/details/" + state.transportId,
                    { replace: true, state: { message: message, type: response.status } });
            }
            else {
                navigate("/" + parents + "/documents/" + state.stopId,
                    { replace: true, state: { message: message, type: response.status } });
            }

        }).catch((error) => {
            console.log(error);
            navigate("/" + parents + "/details/" + state.transportId,
                { replace: true, state: { message: globalErrorMessage, type: "error" } })
        })
    }

    const content = () => {
        return (
            <>
                <Message type="warning" message={warning} />

                <div className="outline-boxes">

                    {/* Article list */}
                    <div className="component">
                        <div className="outline-box outline-box--details" data-match>
                            <h4 className={"details-link details-link--toggle details-link--toggle" + (hidden ? "--active" : "") + " mt-0"} onClick={(e) => showHide()}>
                                {state.stopName}
                            </h4>
                            {hidden === false && (
                                <div className="article-list-plain">

                                    {state.articles.PICKUP.length > 0 &&
                                        <>
                                            <div className="item-title">Opgehaald</div>
                                            {state.articles.PICKUP.map((article) => (
                                                <div className="request-item" key={"article-" + Math.random()}>
                                                    <div className="d-flex flex-column item-value">
                                                        {article.displayLabel}
                                                    </div>
                                                </div>
                                            ))}
                                        </>
                                    }
                                    {state.articles.DROPOFF.length > 0 &&
                                        <>
                                            <div className="item-title">Afgeleverd</div>
                                            {state.articles.DROPOFF.map((article) => (
                                                <div className="request-item" key={"article-" + Math.random()}>
                                                    <div className="d-flex flex-column item-value">
                                                        {article.displayLabel}
                                                    </div>
                                                </div>
                                            ))}
                                        </>
                                    }
                                </div>

                            )}
                        </div>
                    </div>
                    <div className="component">

                        {/* Document text (contract) */}
                        {state.documentArticle !== null &&

                            <div className="outline-box outline-box--details" data-match>
                                <span className="d-flex flex-column">
                                    <h4>{state.documentArticle.title}</h4>
                                </span>
                                <span className="d-flex flex-column" dangerouslySetInnerHTML={{ __html: state.documentArticle.content }}>
                                </span>
                            </div>
                        }

                        {/* Form */}
                        <div className="outline-box outline-box--details" data-match>

                            <FormFields
                                formFields={formFields}
                                setValues={setInputValues}
                                setErrors={setInputErrors}
                                formValues={values}
                                formErrors={errors}
                                //identifier = null
                                isSubmitted={isSubmitted}
                            />

                            {/* form buttons */}
                            <div className="form__row form__row--buttons">
                                <div className="form__component">
                                    <div className="form__element">
                                        <button onClick={() => { handleSubmit() }} className={"button button--primary submit"}>Opslaan</button>
                                    </div>
                                </div>
                                <div className="form__component">
                                    <div className="form__element">
                                        <Link to={"/" + parents + "/details/" + state.transportId} className={"button button--outline"}>
                                            <span>Annuleren</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    // Render
    return (
        <>
            <Message type="info" message={state.document.commentClient} />
            <ContentWrapper content={content()} type="page-component" />
        </>
    );

}